export const getEvents = ({ events: { events } }) => events

export const getFilters = ({ events: { filters } }) => filters

export const getEvent = ({ events: { event } }) => event

export const getCount = ({ events: { count } }) => count

export const getLoading = ({ events: { loading } }) => loading
